var map = {
	"./add-visit.svg": "9c18",
	"./channel.svg": "c2cd",
	"./client.svg": "037c",
	"./customer.svg": "b17f",
	"./dept.svg": "6f9d",
	"./map-green.svg": "507e",
	"./my-center.svg": "820d",
	"./my-visit.svg": "418b",
	"./nationwide.svg": "319d",
	"./province.svg": "7070",
	"./purchase-sell-stock.svg": "9b36",
	"./real-time-screen.svg": "6fa4",
	"./terminal-sales-analysis.svg": "00fc",
	"./tjls-my-center.svg": "ed15",
	"./tjls-purchase-sell-stock.svg": "2187",
	"./tjls-real-time-screen.svg": "4c7a",
	"./tjls-terminal-sales-analysis.svg": "6a2f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";